import Swiper from "swiper"
import "swiper/css"

// $medium in article-slider.scss — below it the cards are a plain stacked
// CSS list (no Swiper at all), at/above it they're a Swiper carousel. A
// one-off check at page load doesn't survive resizing across that breakpoint,
// so this listens for it and creates/destroys the Swiper instance live.
const DESKTOP_QUERY = "(min-width: 768px)"

class ArticleSwiperHandler {
  constructor(root = document) {
    this.sliders = Array.from(root.querySelectorAll(".article-slider__container"))
    this.instances = new Map()
    this.mediaQuery = window.matchMedia(DESKTOP_QUERY)

    this.sync()
    this.mediaQuery.addEventListener("change", () => this.sync())
  }

  sync() {
    this.sliders.forEach(slider => {
      if (this.mediaQuery.matches) {
        if (this.instances.has(slider)) return
        this.instances.set(
          slider,
          new Swiper(slider, {
            slidesPerView: 2.5,
            spaceBetween: 20,
            grabCursor: true,
            breakpoints: {
              1024: {
                slidesPerView: 3.5,
              },
            },
          })
        )
      } else {
        const instance = this.instances.get(slider)
        if (!instance) return
        instance.destroy(true, true)
        this.instances.delete(slider)
      }
    })
  }
}

export default ArticleSwiperHandler
